import { RouterModule, Routes } from '@angular/router';
import { HomePage } from './pages/home/home.page';
import { MapPage } from './explore/map/map.page';

import { LoggedInGuard } from '@spotter/guards/login-guard';
import { addSpotterRoutes } from '@spotter/providers/spotter-providers';
import { ComponentPlaygroundPage } from './pages/component-playground/component-playground.page';
import { ProfileDashboardPage } from './pages/profile-dashboard/profile-dashboard.page';
import { AboutPage } from './pages/about/about.page';

export const routes: Routes = [
    { path: '', component: HomePage },  // Default route (home)

    

    { path: 'projects', loadComponent: () => import('./projects/projects/projects.page').then(m => m.ProjectsPage) }, 
    { path: 'projects/new', loadComponent: () => import('./projects/create-project/create-project.page').then(m => m.CreateProjectPage), canActivate: [LoggedInGuard] }, 
    { path: 'projects/:id', loadComponent: () => import('./projects/project/project.page').then(m => m.ProjectPage) }, 
    { path: 'projects/:id/edit', loadComponent: () => import('./projects/create-project/create-project.page').then(m => m.CreateProjectPage), canActivate: [LoggedInGuard] }, 

    { path: 'sites', loadComponent: () => import('./sites/sites/sites.page').then(m => m.SitesPage) }, 
    { path: 'sites/new', loadComponent: () => import('./sites/create-site/create-site.page').then(m => m.CreateSitePage), canActivate: [LoggedInGuard] }, 
    { path: 'sites/:site_id', loadComponent: () => import('./sites/site/site.page').then(m => m.SitePage) }, 
    { path: 'sites/:id/edit', loadComponent: () => import('./sites/create-site/create-site.page').then(m => m.CreateSitePage), canActivate: [LoggedInGuard] }, 
    { path: 'sites/:id/add-data', loadComponent: () => import('./sites/add-site-data/add-site-data.page').then(m => m.AddSiteDataPage), canActivate: [LoggedInGuard] }, 

    { path: 'organisations', loadComponent: () => import('./organisations/organisations/organisations.page').then(m => m.OrganisationsPage) }, 
    { path: 'organisations/new', loadComponent: () => import('./organisations/create-organisation/create-organisation.page').then(m => m.CreateOrganisationPage), canActivate: [LoggedInGuard] }, 
    { path: 'organisations/:id', loadComponent: () => import('./organisations/organisation/organisation.page').then(m => m.OrganisationPage) }, 
    { path: 'organisations/:id/edit', loadComponent: () => import('./organisations/create-organisation/create-organisation.page').then(m => m.CreateOrganisationPage), canActivate: [LoggedInGuard] }, 
    { path: 'organisations/:id/confirm-membership/:code', loadComponent: () => import('./organisations/confirm-membership/confirm-membership.page').then(m => m.ConfirmMembershipPage) }, 
    

   // { path: 'sites', component: SitesPage },

    { path: 'map',  loadComponent: () => import('./explore/map/map.page').then(m => m.MapPage) }, 

    { path: 'about', loadComponent: () => import('./pages/about/about.page').then(m => m.AboutPage) }, 

     //{path: 'playground', component: ComponentPlaygroundPage },


     {path: 'profile/dashboard', loadComponent: () => import('./pages/profile-dashboard/profile-dashboard.page').then(m => m.ProfileDashboardPage) },
    ...addSpotterRoutes(),
];

